/**
 * 브라우저 API 폴리필.
 *
 * main.tsx에서 **첫 번째 import**로 불러와야 한다.
 * 다른 모든 모듈(Sentry, PostHog, Mixpanel, Supabase 등)보다 먼저
 * 실행되어야 SDK 크래시를 방지할 수 있다.
 */

// navigator.locks — 구버전 WebView, Safari 프라이빗 브라우징 등에서 미지원.
// PostHog·Supabase 등이 내부적으로 사용한다.
// request(name, callback) / request(name, options, callback) 두 시그니처를 모두 처리.
if (typeof navigator !== "undefined" && !navigator.locks) {
  (navigator as any).locks = {
    request: (...args: unknown[]) => {
      const callback = args[args.length - 1] as (lock: unknown) => Promise<unknown>;

      return callback({ name: args[0], mode: "exclusive" });
    },
  };
}

// crypto.randomUUID — HTTP(비보안 컨텍스트) 환경에서 미지원.
// Mixpanel·PostHog 등이 내부적으로 사용한다.
if (typeof crypto !== "undefined" && !crypto.randomUUID) {
  crypto.randomUUID = () =>
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => {
      const n = Number(c);

      return (n ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (n / 4)))).toString(16);
    }) as `${string}-${string}-${string}-${string}-${string}`;
}
